import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home.vue'
import PortfolioItem from '@/views/PortfolioItem.vue'
import PortfolioView from '@/views/PortfolioView.vue'
import Services from '@/views/Services.vue'
import Contact from '@/views/Contact.vue'
const Equipment = () => import('@/views/Equipment.vue')

// portfolioItems
const JobbooWorker = () => import('@/components/portfolio/JobbooWorker.vue')
const JobbooClientLP = () => import('@/components/portfolio/JobbooClientLP.vue')
const JobbooClient = () => import('@/components/portfolio/JobbooClient.vue')
const KitchenRoom = () => import('@/components/portfolio/KitchenRoom.vue')
const JobbooWorkerLP = () => import('@/components/portfolio/JobbooWorkerLP.vue')
const SavageLP = () => import('@/components/portfolio/SavageLP.vue')
const Sportzal = () => import('@/components/portfolio/Sportzal.vue')
const Savage = () => import('@/components/portfolio/Savage.vue')
const Pulsar = () => import('@/components/portfolio/Pulsar.vue')
const Motofreak = () => import('@/components/portfolio/Motofreak.vue')
const Rebalancer = () => import('@/components/portfolio/Rebalancer.vue')
const Stadium = () => import('@/components/portfolio/Stadium.vue')
const Avito = () => import('@/components/portfolio/Avito.vue')
const Payday = () => import('@/components/portfolio/Payday.vue')
const Webshow = () => import('@/components/portfolio/Webshow.vue')
const EquipRequest = () => import('@/views/EquipRequest.vue')
const Solutions = () => import('@/views/Solutions.vue')
const SolutionsEquipment = () => import('@/views/SolutionsEquipment.vue')
const SolutionsPrograms = () => import('@/views/SolutionsPrograms.vue')
const SolutionRequest = () => import('@/views/SolutionRequest.vue')
const GetDiscount = () => import('@/views/GetDiscount.vue')
const EquipCategory = () => import('@/views/equipment/EquipCategory.vue')
const EquipItem = () => import('@/views/EquipItem.vue')
const ItemRequest = () => import('@/views/ItemRequest.vue')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    component: Home,
  }, {
    path: '/portfolio',
    component: PortfolioView
  }, {
    path: '/portfolio/jobbooworker',
    meta: {
      productSlug: 'jobbooworker'
    },
    component: JobbooWorker
  }, {
    path: '/portfolio/webshow',
    meta: {
      productSlug: 'webshow'
    },
    component: Webshow
  }, {
    path: '/portfolio/avito',
    meta: {
      productSlug: 'avito'
    },
    component: Avito
  }, {
    path: '/portfolio/payday',
    meta: {
      productSlug: 'payday'
    },
    component: Payday
  }, {
    path: '/portfolio/rebalancer',
    meta: {
      productSlug: 'rebalancer'
    },
    component: Rebalancer
  }, {
    path: '/portfolio/jobbooclientlp',
    meta: {
      productSlug: 'jobbooclientlp'
    },
    component: JobbooClientLP
  }, {
    path: '/portfolio/stadium',
    meta: {
      productSlug: 'stadium'
    },
    component: Stadium
  }, {
    path: '/portfolio/jobbooclient',
    meta: {
      productSlug: 'jobbooclient'
    },
    component: JobbooClient
  }, {
    path: '/portfolio/kitchenroom',
    meta: {
      productSlug: 'kitchenroom'
    },
    component: KitchenRoom
  }, {
    path: '/portfolio/savagelp',
    meta: {
      productSlug: 'savagelp'
    },
    component: SavageLP
  }, {
    path: '/portfolio/savage',
    meta: {
      productSlug: 'savage'
    },
    component: Savage
  },  {
    path: '/portfolio/motofreak',
    meta: {
      productSlug: 'motofreak'
    },
    component: Motofreak
  }, {
    path: '/portfolio/jobbooworkerlp',
    meta: {
      productSlug: 'jobbooworkerlp'
    },
    component: JobbooWorkerLP
  }, {
    path: '/portfolio/pulsar',
    meta: {
      productSlug: 'pulsar'
    },
    component: Pulsar
  }, {
    path: '/portfolio/sportzal',
    meta: {
      productSlug: 'sportzal'
    },
    component: Sportzal
  }, {
    path: '/portfolio/:slug',
    component: PortfolioItem,
  }, {
    path: '/services',
    component: Services
  }, {
    path: '/equipment',
    component: Equipment
  }, {
    name: 'equipCategory',
    path: '/equipment/:category',
    component: EquipCategory
  }, {
    name: 'equipItem',
    path: '/equipment/:category/:slug',
    component: EquipItem
  }, {
    path: '/solutions',
    component: Solutions,
    children:[{
      path: '',
      component: SolutionsEquipment
    }, {
      path: '/solutions/programs',
      component: SolutionsPrograms
    }]
  },{
    path: '/contact',
    component: Contact
  }, {
    path: '/get-discount',
    component: GetDiscount
  }, {
    path: '/equip-request',
    component: EquipRequest
  }, {
    path: '/solution-request',
    component: SolutionRequest
  }, {
    path: '/item-request',
    component: ItemRequest
  }]
})
